export const ExtractMediaObjectId: (value: string) => string = value => value.substring(0, 64);
